import { useEffect, useState } from "react";
import api from "@/lib/api";

const autoPlaybookIds = (project, playbooks) => {
  const auto = (project.auto_playbook_ids || []).concat(playbooks.filter((x) => x.auto_run_on_new_project && x.scope === "company").map((x) => x.id));
  return [...new Set(auto)].filter((pid) => playbooks.some((x) => x.id === pid));
};

// Loads documents, playbooks, findings and the project for the AI Review page; pre-selects the first document + auto playbooks.
export function useReviewSetup(projectId, workspaceId) {
  const [docs, setDocs] = useState([]);
  const [playbooks, setPlaybooks] = useState([]);
  const [findings, setFindings] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [selectedPBs, setSelectedPBs] = useState([]);
  const [viewingDoc, setViewingDoc] = useState(null);

  const viewDoc = async (docId) => { const full = await api.get(`/documents/${docId}`); setViewingDoc(full.data); };

  useEffect(() => {
    (async () => {
      const [d, p, f, pr] = await Promise.all([api.get(`/projects/${projectId}/documents`), api.get(`/workspaces/${workspaceId}/playbooks`), api.get(`/projects/${projectId}/findings`), api.get(`/projects/${projectId}`)]);
      setDocs(d.data); setPlaybooks(p.data); setFindings(f.data);
      const auto = autoPlaybookIds(pr.data, p.data);
      if (auto.length) setSelectedPBs(auto);
      if (d.data[0]) { setSelectedDocs([d.data[0].id]); await viewDoc(d.data[0].id); }
    })();
  }, [projectId, workspaceId]);

  return { docs, playbooks, findings, setFindings, selectedDocs, setSelectedDocs, selectedPBs, setSelectedPBs, viewingDoc, viewDoc };
}
